import { OrderOperationType } from 'api/types/entity/account/order';
import { DialogContent } from 'components';
import { NavigationLink } from 'components/NavigationLink';
import { useTranslation } from 'libs/i18n';
import { ROUTES } from 'libs/navigation';
import { Dialog, DialogStateProps, Stack } from 'libs/ui';
import { OrderOperationTypeForQuery } from 'modules/account/orderModule/types';

import { Item } from './Item';
import { ContentStyled, LineStyled } from './styles';

interface Props extends DialogStateProps {}

const orderTypes = Object.values(OrderOperationType);

export const DialogCreateOrder = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog fullWidth isOpen={isOpen} maxWidth="lg" onClose={onClose}>
      <DialogContent
        spacingContent={48}
        title={t('account.orders.dialogCreateOrder.title')}
        onClose={onClose}
      >
        <ContentStyled>
          <Stack spacing={24}>
            {orderTypes.map((type, index) => {
              const orderTypeForQuery = OrderOperationTypeForQuery[type];
              return (
                <>
                  <NavigationLink
                    key={orderTypeForQuery}
                    datax={`dialogCreateOrder-${orderTypeForQuery}`}
                    to={`${ROUTES.account.orders.createOrder.fullPath}?type=${orderTypeForQuery}`}
                  >
                    <Item title={t(`account.order.types.${type}`)} />
                  </NavigationLink>
                  {index !== orderTypes.length - 1 && <LineStyled />}
                </>
              );
            })}
          </Stack>
        </ContentStyled>
      </DialogContent>
    </Dialog>
  );
};
